var isSelected = function isSelected(selectedKeys) {
  return selectedKeys === 'all' || selectedKeys instanceof Set && selectedKeys.size > 0;
};
var getSelectTextColor = function getSelectTextColor(isPlaceholder, isDisabled) {
  if (isDisabled) return 'state.disabled';
  if (isPlaceholder) return 'base.subtle';
  return 'base.default';
};

export { getSelectTextColor, isSelected };
//# sourceMappingURL=Select.helpers.js.map
